export const GameFoodPage = () => {
  return <div></div>;
};
